
namespace TabAurous.Inventory {
    //export class MaterialReceiptRowOptions {
    //    items: MaterialReceiptRow[];
    //}

    //export class MaterialReceiptRowPanel extends Serenity.TemplatedPanel<MaterialReceiptRowOptions> {
    //    constructor(container: JQuery, opt: MaterialReceiptRowOptions) {
    //        super(container, opt);

           
    //        //Grouping
    //        var data = this.options.items;
    //        var code = [""];
    //        var grossamount = [0];
    //        code.pop();
    //        grossamount.pop();
    //        for (var i = 0; i < data.length; i++) {
    //            var checkexists = false;
    //            for (var j = 0; j < code.length; j++) {
    //                if (data[i].CompanyName.match(code[j])) {
    //                    checkexists = true;
    //                    grossamount[j] += data[i].GrossAmount;
    //                }
    //            }
    //            if (!checkexists) {
    //                code.push(data[i].CompanyName);
    //                grossamount.push(data[i].GrossAmount);
    //            }
    //        }
    //        var options = {
    //            chart: {
    //                height: 250,
    //                width: 430,
    //                type: 'line',
    //                fontFamily: '"PT Sans", sans-serif',
    //                zoom: {
    //                    enabled: false
    //                }
    //            },
    //            series: [
    //                {
    //                    name: 'sales',
    //                    data: grossamount
    //                }
    //            ],

    //            stroke: {
    //                curve: 'straight'
    //            },
    //            xaxis: {
    //                categories: code
    //            }
    //        }
    //        //var x = document.getElementById('TabAurous_Reports_MaterialReceiptRowPanel13_chartContainer');
    //        var y = container[0].childNodes[0];
    //        var chart = new ApexCharts(y, options);
    //        chart.render();
    //    }

    //    getTemplate() {

    //        return `<div id="~_chartContainer"></div>`;
    //    }
    //}



    @Serenity.Decorators.registerClass()
    export class MaterialReceiptRegisterGrid extends Serenity.EntityGrid<MaterialReceiptRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialReceipt'; }
        protected getDialogType() { return MaterialReceiptDialog; }
        protected getIdProperty() { return MaterialReceiptRow.idProperty; }
        protected getInsertPermission() { return MaterialReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return MaterialReceiptRow.localTextPrefix; }
        protected getService() { return MaterialReceiptService.baseUrl; }
        //private chartContainer: JQuery;
        //private chartPanel: ChartPanel;
        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.FinancialYearRow.lookupKey,
                    multiple: true

                },
                field: 'FinancialYearId',
                title: 'Year',
                handler: w => {
                    var temp= [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).FinancialYearIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    }
                },
                
                cssClass: 'hidden-xs'
            });
            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).CompanyIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            

            return filters;
        }

        //onViewProcessData(response: Serenity.ListResponse<MaterialReceiptRow>) {

        //    if (!this.chartContainer) {
        //        this.chartContainer = $("<div style='padding: 20px 0' />");
        //        this.chartContainer.insertBefore(this.element.find(".grid-container"));
        //    }

        //    if (this.chartPanel) {
        //        this.chartPanel.destroy();
        //    }

        //    this.chartPanel = new MaterialReceiptRowPanel(this.chartContainer, { items: response.Entities });

        //    var options = {
        //        chart: {
        //            type: 'bar'
        //        },
        //        series: [
        //            {
        //                name: 'sales',
        //                data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
        //            }
        //        ],
        //        xaxis: {
        //            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        //        }
        //    }

        //    var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

        //    chart.render();


        //    return response;
        //}

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    
                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalReturnRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date:this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}